/* eslint-disable react/jsx-filename-extension */
import React, { useRef, useEffect } from 'react';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useDrag, useDrop, XYCoord, } from 'react-dnd'
import { SelectedItem, ItemKind, DraggingSelectedItemData } from './types';
import { ItemRow, ItemRowProps } from './ItemRow';

export interface SelectedItemRowDragHoverCallback {
  (draggingItemData: DraggingSelectedItemData, clientOffset: XYCoord): void;
}

export interface SelectedItemRowDropCallback {
  (draggingItemData: DraggingSelectedItemData): void;
}

export interface SelectedItemRowProps<T> extends ItemRowProps<T> {
  draggingHoverCallback?: SelectedItemRowDragHoverCallback;
  dropCallback?:SelectedItemRowDropCallback;
}

export const SelectedItemRow = <T extends SelectedItem>(props: SelectedItemRowProps<T>) => {
  const {
    data,
    index,
    draggingHoverCallback,
    dropCallback,
  } = props;
  if (data === undefined) {
    throw new Error('data is necessary for dragging');
  }

  const dragObject: DraggingSelectedItemData = {
    ...data, index,
  }

  const [{ isDragging, }, dragRef, preview] = useDrag({
    type: ItemKind.selected,
    item: dragObject,
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });
  useEffect(() => {
    preview(getEmptyImage());
  }, []);

  const [, dropRef] = useDrop<DraggingSelectedItemData, unknown, unknown>({
    accept: ItemKind.selected,
    hover: (draggingItemData, monitor) => {
      draggingHoverCallback?.(draggingItemData, monitor.getClientOffset());
    },
    drop: (draggingItemData) => {
      dropCallback?.(draggingItemData);
    }
  });

  const ref = useRef(null);
  dropRef(dragRef(ref));
  return (
    <ItemRow
{...props}
      className={isDragging ? 'dragging' : ''}
      rootRef={ref}
    />
  );
}
